<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-md-8 mx-auto">
                <div class="card">
                    <div class="card-header pb-0">
                        <div class="d-flex align-items-center">
                            <p class="mb-0">Crear Unidad de Medida</p>
                        </div>
                    </div>
                    <div class="card-body">
                        <form @submit.prevent="submitUnit">
                            <div class="row">
                                <div class="col-md-6">
                                    <label class="form-control-label">Código (Abreviatura)</label>
                                    <argon-input v-model="unit.code" type="text" placeholder="Ej: UN, LT, CAJ" />
                                    <small v-if="submitted && v$.unit.code.$error" class="text-danger">Código (Abreviatura) requerido.</small>
                                </div>
                                <div class="col-md-6">
                                    <label class="form-control-label">Nombre</label>
                                    <argon-input v-model="unit.name" type="text" placeholder="Ej: Unidad, Litro, Caja" />
                                    <small v-if="submitted && v$.unit.name.$error" class="text-danger">Nombre de la unidad requerido.</small>
                                </div>
                                <div class="col-md-6">
                                    <label class="form-control-label">Estado</label>
                                    <select class="form-control" v-model="unit.state">
                                        <option value="1">Activo</option>
                                        <option value="2">Inactivo</option>
                                    </select>
                                    <small v-if="submitted && v$.unit.state.$error" class="text-danger">Estado requerido.</small>
                                </div>
                            </div>
                            <argon-button
                                type="submit"
                                class="mt-4"
                                color="success"
                                fullWidth
                                size="lg"
                            >
                                Guardar Unidad
                            </argon-button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import { useVuelidate } from '@vuelidate/core';
import { required, helpers } from '@vuelidate/validators';
import axios from "axios";
import Swal from 'sweetalert2';

export default {
    name: "CreateUnit",
    components: { ArgonInput, ArgonButton },
    setup: () => ({ v$: useVuelidate() }),
    data() {
        // 🛑 CRÍTICO: El company ID se toma del localStorage al inicializar
        const companyId = parseInt(localStorage.getItem('companyId'));

        return {
            submitted: false,
            unit: {
                code: '',
                name: '',
                state:1,
                company: companyId || null
            }
        };
    },
    validations() {
        return {
            unit: {
                code: { required: helpers.withMessage('El código es requerido', required) },
                name: { required: helpers.withMessage('El nombre es requerido', required) },
                state: { required: helpers.withMessage('El estado es requerido', required) },
                // Aseguramos que el company ID exista, aunque ya viene de localStorage
                company: { required: helpers.withMessage('ID de compañía faltante (Reinicie sesión)', required) }
            }
        };
    },
    methods: {
        submitUnit() {
            this.submitted = true;
            this.v$.$touch();

            // 1. Validar Vuelidate (incluye la verificación del Company ID)
            if (this.v$.$invalid) {
                Swal.fire({
                    title: 'Datos inválidos',
                    text: 'Por favor, revisa los campos requeridos y el formato.',
                    icon: 'warning',
                    confirmButtonColor: '#0b9257'
                });
                return;
            }

            const token = localStorage.getItem("accessToken");
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'accept': '*/*',
                    'Authorization': `Bearer ${token}`
                }
            };

            // 2. Ejecutar la solicitud POST
            axios.post(this.$store.state.apiURL + 'units', this.unit, config)
                .then((result) => {
                    console.log(result);
                    Swal.fire({
                        title: 'Unidad Creada',
                        text: 'La unidad de medida fue registrada correctamente.',
                        icon: 'success',
                        confirmButtonColor: '#0b9257'
                    }).then(() => {
                        this.$router.push('/settings/units');
                    });
                })
                .catch((err) => {
                    console.error("Error al crear unidad:", err.response || err);
                    let errorText = 'No se pudo guardar la unidad.';

                    if (err.response && err.response.data && err.response.data.error && err.response.data.error.includes('Duplicate entry')) {
                         errorText = 'El código ya existe en tu compañía. (Unique constraint error)';
                    } else if (err.response && err.response.data && err.response.data.error) {
                         errorText = err.response.data.error;
                    }

                    Swal.fire({
                        title: 'Error',
                        text: errorText,
                        icon: 'error',
                        confirmButtonColor: '#0b9257'
                    });
                });
        }
    }
};
</script>